// views/Settings/SettingsRedirect.js
// An old settings route, kept so bookmarks and in-app links still land.
import React from "react";
import { Redirect } from "react-router-dom";

export const settingsRedirectTo = (to) => {
  const R = () => <Redirect to={to} />;
  R.displayName = `SettingsRedirect(${to})`;
  return R;
};

/**
 * An old section address that moved, keeping the chosen tab: the old
 * /admin/settings/commission-tax?tab=vendor-tax lands on the same tab at its
 * new address under Tax.
 */
export const settingsRedirectKeepingQuery = (pathname) => {
  const R = ({ location }) => <Redirect to={{ pathname, search: location?.search || "" }} />;
  R.displayName = `SettingsRedirect(${pathname}, keeps query)`;
  return R;
};

export default settingsRedirectTo;
